/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Pedal_Source_WebhidInputs */



/**
* | output |
* | --- |
* | "WebHID Device" |
*
* @param {Options_Pedal_Source_WebhidInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_pedal_source_webhid = /** @type {((inputs?: Options_Pedal_Source_WebhidInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Pedal_Source_WebhidInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("WebHID Device")
	if (locale === "de") return /** @type {LocalizedString} */ ("WebHID Device")
	if (locale === "it") return /** @type {LocalizedString} */ ("WebHID Device")
	if (locale === "ru") return /** @type {LocalizedString} */ ("WebHID Device")
	if (locale === "es") return /** @type {LocalizedString} */ ("WebHID Device")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("WebHID Device")
	if (locale === "ja") return /** @type {LocalizedString} */ ("WebHID Device")
	if (locale === "hi") return /** @type {LocalizedString} */ ("WebHID Device")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("WebHID Device")
	return /** @type {LocalizedString} */ ("WebHID Device")
});